<div class="card">
  <div class="card-body py-2 px-3">
    @if (isLoading()) {
      <div class="d-flex justify-content-center py-2">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (data()) {
      <div class="d-flex align-items-center gap-4 flex-wrap">
        <span class="priv-title fw-semibold">Privileged Access</span>

        <kendo-dropdownbutton
          kendoButton
          class="ms-auto order-last"
          [svgIcon]="moreVerticalIcon"
          fillMode="flat"
          size="small"
          [data]="menuItems"
          (itemClick)="onMenuSelect($event)"
        ></kendo-dropdownbutton>

        <div class="priv-metric" [class.priv-metric--over]="data()!.global_admins > data()!.recommended_max_admins">
          <span class="priv-metric__value">{{ data()!.global_admins }}</span>
          <span class="priv-metric__label">Global Admins</span>
          @if (data()!.global_admins > data()!.recommended_max_admins) {
            <span class="priv-metric__flag">Reduce to &le;{{ data()!.recommended_max_admins }}</span>
          }
        </div>

        <div class="priv-divider"></div>

        <div class="priv-metric">
          <span class="priv-metric__value">{{ data()!.accounts_can_create_tokens }}</span>
          <span class="priv-metric__label">Token Creators</span>
        </div>

        <div class="priv-divider"></div>

        <div class="priv-metric">
          <span class="priv-metric__value">{{ data()!.accounts_can_reset_passwords }}</span>
          <span class="priv-metric__label">Password Resetters</span>
        </div>

        <div class="priv-divider"></div>

        <div class="priv-metric">
          <span class="priv-metric__value">{{ data()!.accounts_can_grant_permissions }}</span>
          <span class="priv-metric__label">Permission Granters</span>
        </div>
      </div>
    }
  </div>
</div>
